import {
  getSavedOrders,
  getPlacedOrders,
  getAllOrders,
  getCanceledOrders,
  getRecentlyShippedOrders,
  getCustomerChangedOrders,
  getMyRecentOrders,
  getOrderById,
  getOrderTabCounts,
  insertOrder,
  updateOrder,
} from '../../../services/requests/orders/orders-requests';
import { DataSource, registerDataSource } from '../../UI/view/data-source';

export const ordersDataSource = {
  name: 'orders',
  request: getSavedOrders,
  entityRequest: getOrderById,
  createRequest: insertOrder,
  updateRequest: updateOrder,
  serverSideEvents: true,
  pk: 'id',
} as DataSource;

// Dedicated data source for the routable Create Order page (replaces the old
// create modal). Kept separate from `ordersDataSource` so the create page's
// redux slice does not collide with the edit page's slice.
export const ordersCreateDS = {
  name: 'ordersCreate',
  request: getSavedOrders,
  entityRequest: getOrderById,
  createRequest: insertOrder,
  updateRequest: updateOrder,
  serverSideEvents: true,
  pk: 'id',
} as DataSource;

export const savedOrdersDS = {
  name: 'savedOrders',
  request: getSavedOrders,
  entityRequest: getOrderById,
  createRequest: insertOrder,
  updateRequest: updateOrder,
  serverSideEvents: false,
  pk: 'id',
} as DataSource;

export const placedOrdersDS = {
  name: 'placedOrders',
  request: getPlacedOrders,
  entityRequest: getOrderById,
  createRequest: insertOrder,
  updateRequest: updateOrder,
  serverSideEvents: false,
  pk: 'id',
} as DataSource;

export const allOrdersDS = {
  name: 'allOrders',
  request: getAllOrders,
  entityRequest: getOrderById,
  createRequest: insertOrder,
  updateRequest: updateOrder,
  serverSideEvents: true,
  pk: 'id',
} as DataSource;

export const canceledOrdersDS = {
  name: 'canceledOrders',
  request: getCanceledOrders,
  serverSideEvents: false,
  pk: 'id',
} as DataSource;

export const recentlyShippedOrdersDS = {
  name: 'recentlyShippedOrders',
  request: getRecentlyShippedOrders,
  serverSideEvents: false,
  pk: 'id',
} as DataSource;

export const customerChangedOrdersDS = {
  name: 'customerChangedOrders',
  request: getCustomerChangedOrders,
  serverSideEvents: false,
  pk: 'id',
} as DataSource;

export const myRecentOrdersDS = {
  name: 'myRecentOrders',
  request: getMyRecentOrders,
  serverSideEvents: false,
  pk: 'id',
} as DataSource;

export const ordersPermissions = {
  read: [1, 2, 29, 30, 31],
  // No write-role restriction for ordinary create/save, matching legacy.
  write: undefined,
  admin: [1, 31],
};

export const ordersActionPermissions = {
  ...ordersPermissions,
  write: [1, 30, 31],
};

// Tab badge counts use the reusable data-source (single-object payload) rather
// than a bespoke slice, so they inherit the out-of-order-response guard and the
// self-registering reducer pattern for free. Badges read `state.orderTabCounts.data`.
export const orderTabCountsDS = {
  name: 'orderTabCounts',
  request: getOrderTabCounts,
  pk: 'id',
} as DataSource;

export const fetchOrderTabCounts = registerDataSource(orderTabCountsDS).fetchData;